module.exports = __webpack_public_path__ + "4655237e06a6fcf48194eee3371cf302.jpg";